import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { Brand, BrandDetail } from 'src/app/models/camera';
import { ArgusApiService } from 'src/app/services/argus-api.service';
import { ModelDetail } from '../../models/model';

@Component({
  selector: 'app-refences',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss']
})
export class ReferencesComponent implements OnInit, OnDestroy {
  models: Array<ModelDetail> = [];
  brands: Array<Brand>;
  model: ModelDetail;
  helperModelOpacityCls = true;
  brandIdSelected: number;
  modelSelected: ModelDetail;
  isLoading = false;

  loadingBrandTxt = "Chargement des marques...";
  loadingModelTxt = "Chargement des modèles...";

  brandSubscription: Subscription;

  constructor(private apiService: ArgusApiService) { }

  ngOnInit() {
    this.brandSubscription = this.apiService.getBrands()
      .subscribe((res: Brand[]) => this.brands = res);
  }

  ngOnDestroy() {
    this.brandSubscription.unsubscribe();
  }

  isBrandSelected(brandId: number): boolean {
    return brandId == this.brandIdSelected;
  }

  isModelSelected(model: ModelDetail): boolean {
    if (model && this.modelSelected) {
      return model.id == this.modelSelected.id;
    }
  }

  onSelectionBrand(event: MatSelectionListChange): void {
    this.getModels(event.options[0].value);
    this.brandIdSelected = event.options[0].value;
  }

  onSelectBrand(event: MatSelectChange): void {
    this.getModels(event.value);
    this.brandIdSelected = event.value;
  }

  onSelectionModel(event: MatSelectionListChange): void {
    this.model = event.options[0].value;
    this.modelSelected = event.options[0].value;
  }

  onSelectModel(event: MatSelectChange): void {
    this.model = event.value;
    this.modelSelected = event.value;
  }

  getModels(brandId: number): void {
    this.isLoading = true;
    this.models = [];
    this.model = null;
    this.modelSelected = null;

    this.apiService.getBrand(brandId).toPromise()
      .then((res: Array<ModelDetail>) => {
        this.models = res;
        this.helperModelOpacityCls = this.models.length == 0;
      })
      .finally(() => this.isLoading = false)
  }

  /**
   * item could be models or brands
   */
  trackById(index: number, item: any): number {
    return item.id;
  }
}